import ProductAddToCartHOC from '@common/components/ProductAddToCartHOC';
import { ReactComponent as ShipIcon } from '@common/icons/ShipIcon.svg';
import Product from '@common/models/Product';
import { PRODUCT_TYPE } from '@common/models/Product';
import { addProductToCart } from '@common/store/cart/slice';
import { addToast } from '@common/store/toasts/slice';
import Gallery from '@components/Gallery';
import ProductAddToCart from '@components/ProductAddToCart';
import StarRating from '@components/Rating/StarRating';
import Editor from '@lib/Editor';
import classnames from 'classnames';
import React from 'react';

export interface ProductProps {
  type?: string;
  isZoomEnabled?: boolean;
  quickView?: boolean;
  product: Product;
  cartProductQuantity: number;
  review: number;
  addToast: typeof addToast;
  addProductToCart: typeof addProductToCart;
  storeType: string;
  wishListFeature: boolean;
  productVideoFeature: boolean;
  // closeModal?: () => void;
}

const ProductComponent: React.FunctionComponent<ProductProps> = ({
  isZoomEnabled = false,
  quickView,
  product,
  cartProductQuantity,
  addToast,
  review,
  reviewsCount,
  addProductToCart,
  storeType,
  wishListFeature,
  productVideoFeature,
  // closeModal,
}) => {
  return (
    <ProductAddToCartHOC
      variantSetToMinQuantity={true}
      disableSuccessToasts={() => false}
      product={product}
      render={(hocArgs) => {
        const { finalProduct } = hocArgs;
        const StarRatingValue = finalProduct.averageRating;
        return (
          <div className={classnames(`w-full`, { 'md:ml-40': !quickView })}>
            <div
              className={classnames(`bg-white rounded-md `, {
                'pb-0': !quickView,
                '': quickView,
              })}
            >
              <div className="flex flex-wrap md:flex-no-wrap ipadQuickView">
                <div
                  className={classnames('w-full md:w-400', {
                    'mb-0': !quickView,
                    '': quickView,
                  })}
                >
                  <Gallery
                    isZoomEnabled={isZoomEnabled}
                    images={finalProduct.images.length ? finalProduct.images : product.images}
                    quickView={quickView}
                    imageDescription={`${finalProduct.images.length ? finalProduct.title : product.title}${
                      finalProduct?.optionValues?.length ? '_' + finalProduct?.optionValues.join('_') : ''
                    }`}
                    productVideoUrl={finalProduct.productVideoUrl}
                    productVideoEnabled={productVideoFeature ? finalProduct.productVideoEnabled : false}
                  />
                  {product.type === PRODUCT_TYPE.PHYSICAL ? (
                    <div className="mt-22 flex hidden items-center justify-center text-13 mb-6 text-shipIn-text">
                      <ShipIcon></ShipIcon>
                      <div className="ml-6" font-customisation="para-text" color-customisation="page-body-text">
                        Standard shipping in {finalProduct.shipInDays} working days
                      </div>
                    </div>
                  ) : null}
                </div>
                <div
                  className={classnames(`flex flex-col md-w-3/4 md:mt-0`, {
                    'mb-0 md:ml-34': !quickView,
                    'md:ml-26 ': quickView,
                  })}
                >
                  <div
                    className={classnames('flex ', {
                      'pt-18 md:p-0': parseInt(StarRatingValue) > 0,
                    })}
                  >
                    {parseInt(StarRatingValue) > 0 ? (
                      <div
                        className="flex text-theme pr-6 text-opacity-60 text-14 font-medium pl-0 md:pl-6 border border-opacity-60 border-theme border-l-0 border-r-1 border-t-0 border-b-0"
                        font-customisation="para-text"
                      >
                        <StarRating
                          rating={parseInt(StarRatingValue) ? parseInt(StarRatingValue) : 0}
                          halfRating={parseInt(StarRatingValue) ? (Number.isInteger(StarRatingValue) ? 0 : 1) : 0}
                          total={5}
                          isInteractive={false}
                          className="mr-4"
                        />
                        {parseInt(StarRatingValue) ? Math.round(StarRatingValue * 10) / 10 : 0}
                      </div>
                    ) : null}
                    {review > 0 ? (
                      <div
                        onClick={() => {
                          if (!quickView) {
                            const elmntToView = document.getElementById('Review');
                            elmntToView.scrollIntoView();
                          }
                        }}
                        className="text-theme cursor-pointer text-opacity-60 underline text-12 md:text-14 pl-6 font-medium"
                        font-customisation="para-text"
                      >
                        {reviewsCount} Reviews
                      </div>
                    ) : null}
                  </div>
                  <h1
                    className={classnames('text-16 md:text-32 font-semibold text-theme mt-24 md:mt-20 md:leading-50', {
                      'w-9/12': quickView,
                    })}
                    font-customisation="section-heading"
                    color-customisation="page-heading"
                    id="product-title"
                  >
                    {finalProduct.title}
                  </h1>
                  <ProductAddToCart
                    product={product}
                    addToast={addToast}
                    cartProductQuantity={cartProductQuantity}
                    addProductToCart={addProductToCart}
                    hocArgs={hocArgs}
                    storeType={storeType}
                    quickView={quickView}
                    wishListFeature={wishListFeature}
                    // closeModal={closeModal}
                  />
                </div>
              </div>
              {/* {finalProduct.shortDescription && !quickView ? (
          <div className="w-full mt-20">
            <div className={classnames('text-theme text-24 mb-16 font-semibold')}>Overview</div>
            <Editor name="productShortDescription" value={finalProduct.shortDescription} readonly={true} />
          </div>
        ) : null} */}
            </div>
            {finalProduct.description && !quickView ? (
              <div className={'bg-white md:mt-74 pb-16 rounded-md md:px-20'}>
                <div
                  className="text-theme text-14 md:text-24 mb-8 md:mb-24 font-semibold md:leading-loose"
                  font-customisation="section-heading"
                  color-customisation="page-heading"
                >
                  Product Description
                </div>
                <Editor
                  name="productLongDescription"
                  value={finalProduct.description}
                  readonly={true}
                  isDefaultFont={true}
                  className="px-0 py-0 md:px-14 md:py-12"
                />
              </div>
            ) : null}
          </div>
        );
      }}
    />
  );
};

export default ProductComponent;
